module.exports = __webpack_public_path__ + "img/title-01.0e3009f5.png";